export default __webpack_public_path__ + "static/media/check.b9dc9214.svg";